import React, { useState, useRef } from 'react';
import Plaque from './Plaque';
import './Hallway.css';

function Hallway({ data = [], artistBios, plaqueRefs }) {
    const [collageLoaded, setCollageLoaded] = useState(false);

    const currentlyPlayingVideo = useRef(null);
    
      const handleVideoPlay = (videoEl) => {
        if (currentlyPlayingVideo.current && currentlyPlayingVideo.current !== videoEl) {
          currentlyPlayingVideo.current.pause();
        }
        currentlyPlayingVideo.current = videoEl;
      };

    return (
        <div>
            <div 
                className="collage-wrapper"
                style={{ position: 'relative' }}
                ref={(el) => (plaqueRefs.current[-1] = el)}
            >
                {!collageLoaded && (
                <div className="spinner-wrapper">
                    <div className="spinner" />
                </div>
                )}

                <picture>
                    <source
                        media="(max-width: 768px)"
                        srcSet="/collages/hallway_collage_mobile_result.webp"
                    />
                    <img
                        className="hallwayTiles"
                        alt="hallway-tiles"
                        loading="lazy"
                        src="/collages/hallway_collage_result.webp"
                        onLoad={() => setCollageLoaded(true)}
                    />
                </picture>
            </div>
            {data.map((piece, index) => (
                <div
                    key={index}
                    className="art-piece"
                    ref={(el) => (plaqueRefs.current[index] = el)}
                >
                    <Plaque piece={piece} artistBios={artistBios} nameClickable={true} onVideoPlay={handleVideoPlay} />
                </div>
            ))}
        </div>
    )
}

export default Hallway;